export function reviews() {

    let expand = document.querySelectorAll('[data-expand="reviews"]');
    expand.forEach( function(elem) {
        let textBlock = elem.parentNode.parentNode.querySelector('[data-text="reviews"]'),
            maxWordCount = window.innerWidth > 779  ? 542 : 266;
        if (textBlock.textContent.length <= maxWordCount) {
            elem.style.opacity = 0;
        }

        elem.addEventListener('click', function() {
            expand.forEach( function(item) {
                let expandParent = item.parentNode,
                    reviewsWrapper = expandParent.parentNode,
                    navi = expandParent.querySelector('[am-navigation="reviews"]'),
                    text = reviewsWrapper.querySelector('[data-text="reviews"]');
                    text.classList.toggle('is-active');
                    navi.classList.toggle('is-active');

                if (text.classList.contains('is-active')) {
                    item.textContent = 'Свернуть';
                } else {
                    item.textContent = 'Развернуть';
                }
            });
        });
    });

    let redirects = document.querySelectorAll('[data-link]');
    redirects.forEach( function(item) {
        item.addEventListener('click', function() {
            let link = item.dataset.link;
            window.open(link);
        })
    })
}
